import { mapState } from "vuex";

import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  EMPTY_CART,
} from '~/store/cart/constants';

export default {
  methods: {
    async addToCart(item) {
      try {
        // Add to store first
        await this.$store.dispatch(ADD_TO_CART, item);

        // Track with Analytics Manager
        if (typeof window !== 'undefined' && window.$analytics) {
          window.$analytics.track('add_to_cart', {
            currency: 'EUR',
            value: item.price || 0,
            items: [{
              item_id: item.id,
              item_name: item.name || item.public_name,
              price: item.price || 0,
              quantity: item.quantity || 1,
              item_category: item.category || 'accommodation',
              item_brand: this.$store.state.search?.singleRequest?.data?.brand || ''
            }]
          });
        }

        // Track view_cart if this is the first item in cart
        if (this.cartItems.length === 1 && typeof window !== 'undefined' && window.$analytics) {
          window.$analytics.track('view_cart', {
            currency: 'EUR',
            value: this.getCartTotal(),
            items: this.cartItems.map(cartItem => ({
              item_id: cartItem.id,
              item_name: cartItem.name || cartItem.public_name,
              price: cartItem.price || 0,
              quantity: cartItem.quantity || 1
            }))
          });
        }

        console.log('[Cart] Item added successfully:', item.id);
      } catch (error) {
        console.error('[Cart] Failed to add item:', error);
        throw error;
      }
    },

    async removeFromCart(id) {
      try {
        // Track removal first (while item still exists in cart)
        const item = this.cartItems.find(item => item.id === id);

        if (item && typeof window !== 'undefined' && window.$analytics) {
          window.$analytics.track('remove_from_cart', {
            currency: 'EUR',
            value: item.price || 0,
            items: [{
              item_id: item.id,
              item_name: item.name || item.public_name,
              price: item.price || 0,
              quantity: item.quantity || 1,
              item_category: item.category || 'accommodation',
              item_brand: this.$store.state.search?.singleRequest?.data?.brand || ''
            }]
          });
        }

        // Then remove from store
        await this.$store.dispatch(REMOVE_FROM_CART, id);

        console.log('[Cart] Item removed successfully:', id);
      } catch (error) {
        console.error('[Cart] Failed to remove item:', error);
        throw error;
      }
    },
    async emptyCart() {
      try {
        await this.$store.dispatch(EMPTY_CART);
        console.log('[Cart] Cart emptied successfully');
      } catch (error) {
        console.error('[Cart] Failed to empty cart:', error);
        throw error;
      }
    },

    /**
     * Get total cart value for display
     */
    getCartTotal() {
      return this.cartItems.reduce((total, item) => {
        const itemTotal = item.rates?.reduce((sum, rate) => {
          return sum + parseFloat(rate.amount || 0);
        }, 0) || 0;
        return total + itemTotal * (item.quantity || 1);
      }, 0);
    },

    /**
     * Get total number of rooms in cart
     */
    getTotalRooms() {
      return this.cartItems.reduce((total, item) => {
        return total + (item.quantity || 1);
      }, 0);
    },

    /**
     * Get total number of guests
     */
    getTotalGuests() {
      return this.cartItems.reduce((total, item) => {
        return total + ((item.guests || 2) * (item.quantity || 1));
      }, 0);
    },
    isAddedCart(roomType) {
      return this.cartItems.filter(item => {
        return item.id === roomType.id && item.guests === roomType.guests
      }).length > 0;
    },
    /**
     * Not ok when property is not occupational, guest check is required
     * @param {*} id 
     * @returns 
     */
    quantityCart(id) {
      let quantity = 0;

      this.cartItems.forEach(item => {
        if (!id || item.id === id) {
          quantity += item.quantity;
        }
      });

      return quantity;
    },
    quantityCartGuest(roomType) {
      let quantity = 0;

      this.cartItems.forEach(item => {
        if (
          !roomType ||
          (item.id === roomType.id && item.guests === roomType.guests)
        ) {
          quantity += item.quantity;
        }
      });

      return quantity;
    },
  },
  computed: {
    ...mapState({
      cartItems: state => state.cart.items,
    }),
  }
}
